import '../httpservices/core/ajax.httpservice.core';

export class AjaxFileUploader {

    //is this a temporary upload ie: financial forms - upload then render to pdf and will never be sent in a psm
    UploadFile(fileElementChangeObject, attachmentGroupId, isTempUpload) {

        //create a promise which we will return after the ajax upload
        var d = $.Deferred();
        
        //go grab the psm upload information
        $.post('api/Message/UploadToPsmConfiguration')
            .done(response => {

                var progressCallBack = (e) => {
                    //go send progress to the promise so we can report and update the progress bar
                    d.notify(this.ProgressCalculation(e));
                };

                //set the headers
                var headers = [{
                    key: 'CurrentPatId',
                    value: response.currentPatId
                },
                {
                    key: 'Authorization',
                    value: 'Bearer ' + response.ssoToken
                }];
      
                //go run the file upload
                $.fileUpload(`${response.psmUploadUrl}${attachmentGroupId}?isTemp=${isTempUpload}`, this.BuildDataStringForUpload(fileElementChangeObject), headers, progressCallBack)
                    .done(response => {

                        //all done...resolve the promise
                        d.resolve(response);
                    }).fail(errResponse => {

                        $.post('Patient/General/LogUploadError', JSON.stringify(errResponse));
                        //failed so we reject it
                        d.reject(errResponse);
                    });
            });

        return d.promise();
    }

    UploadFileToWebUiApi(fileElementChangeObject, attachmentGroupId) {

        //create a promise which we will return after the ajax upload
        var d = $.Deferred();

        var progressCallBack = (e) => {
            //go send progress to the promise so we can report and update the progress bar
            d.notify(this.ProgressCalculation(e));
        }

        //go run the file upload
        $.fileUpload(_root + 'api/Message/UploadTempFile?attachmentGroupId=' + attachmentGroupId, this.BuildDataStringForUpload(fileElementChangeObject), null, progressCallBack)
            .done(response => {
                //all done...resolve the promise
                d.resolve(response);
            }).fail(errResponse => {

                //failed so we reject it
                d.reject(errResponse);
            });

        return d.promise();
    }

    BuildDataStringForUpload(fileElementChangeObject) {
        var dataString = new FormData();

        dataString.append("uploadedFile", fileElementChangeObject);

        return dataString;
    }

    ProgressCalculation(e) {
        if (e.lengthComputable) {
            //go send progress to the promise so we can report and update the progress bar
            return Math.round((e.loaded * 100) / e.total);
        }
    }

}